<template>
  <a-layout style="min-height: 100vh; background: #F5F6F8">
    <!-- 侧边栏 -->
    <a-layout-sider v-model:collapsed="collapsed" collapsible :width="220" :collapsed-width="isMobile ? 0 : 80"
      :breakpoint="'lg'" theme="light" class="app-sider" @breakpoint="onBreakpoint">
      <div class="sider-logo">
        <LottieIcon :animation-data="runOxAnimation" :size="collapsed ? 300 : 300" />
        <span v-if="!collapsed" class="logo-text"></span>
      </div>
      <a-menu v-model:selectedKeys="selectedKeys" v-model:openKeys="openKeys" theme="light" mode="inline"
        class="app-menu" @click="handleMenuClick">
        <a-menu-item v-if="hasMenu('/dashboard')" key="/dashboard">
          <template #icon>
            <DashboardOutlined />
          </template>
          <span>控制台</span>
        </a-menu-item>
        <a-sub-menu v-if="hasOrderMenu" key="order">
          <template #icon>
            <BarChartOutlined />
          </template>
          <template #title>订单统计</template>
          <a-menu-item v-if="hasMenu('/order/daily')" key="/order/daily">全收款</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/app-daily')" key="/order/app-daily">日收款</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/hourly-payment')" key="/order/hourly-payment">小时统计</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/link-stats')" key="/order/link-stats">链接统计</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/customer-service-stats')" key="/order/customer-service-stats">客服统计</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/hlb-service-transfer-stats')" key="/order/hlb-service-transfer-stats">合利宝转接</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/app-monthly')" key="/order/app-monthly">月收款</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/ltv')" key="/order/ltv">LTV-应用</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/ltv-v2')" key="/order/ltv-v2">LTV-维度</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/pay-refund-daily')" key="/order/pay-refund-daily">收退款-财务</a-menu-item>
          <!-- 每日订单 已隐藏 -->
          <!-- <a-menu-item
            v-if="hasMenu('/order/daily-stat')"
            key="/order/daily-stat"
          >每日订单</a-menu-item> -->
          <a-menu-item v-if="hasMenu('/order/deduction-tag-daily')" key="/order/deduction-tag-daily">预扣款统计</a-menu-item>
          <a-menu-item v-if="hasMenu('/order/deduction-forecast-v2')" key="/order/deduction-forecast-v2">预扣款统计V2</a-menu-item>
        </a-sub-menu>
        <a-sub-menu v-if="hasOperateMenu" key="operate">
          <template #icon>
            <CustomerServiceOutlined />
          </template>
          <template #title>运营工具</template>
          <a-menu-item v-if="hasMenu('/operate/user-query')" key="/operate/user-query">客服查询</a-menu-item>
          <a-menu-item v-if="hasMenu('/operate/external-agreement-conf')" key="/operate/external-agreement-conf">外部配置</a-menu-item>
          <a-menu-item v-if="hasMenu('/operate/ocean-engine-conversion')" key="/operate/ocean-engine-conversion">巨量回传</a-menu-item>
          <a-menu-item v-if="hasMenu('/operate/fusion-payment-config')" key="/operate/fusion-payment-config">融合支付配置</a-menu-item>
          <a-menu-item v-if="hasMenu('/operate/ad-platform-app')" key="/operate/ad-platform-app">投放媒体</a-menu-item>
        </a-sub-menu>
        <a-sub-menu v-if="hasAdMenu" key="ad">
          <template #icon>
            <NotificationOutlined />
          </template>
          <template #title>广告管理</template>
          <a-menu-item v-if="hasMenu('/ad/rules')" key="/ad/rules">规则配置</a-menu-item>
        </a-sub-menu>
        <a-sub-menu v-if="hasSystemMenu" key="system">
          <template #icon>
            <SettingOutlined />
          </template>
          <template #title>系统管理</template>
          <a-menu-item v-if="hasMenu('/system/user')" key="/system/user">用户管理</a-menu-item>
          <a-menu-item v-if="hasMenu('/system/role')" key="/system/role">角色权限</a-menu-item>
        </a-sub-menu>

      </a-menu>
    </a-layout-sider>

    <!-- 右侧布局 -->
    <a-layout style="background: #F5F6F8">
      <!-- 顶部导航 -->
      <a-layout-header class="header">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>{{ currentTitle }}</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="header-right">
          <a-dropdown>
            <a class="user-info" @click.prevent>
              <a-avatar size="small" :src="avatarImg" />
              <span class="username">{{ username }}</span>
              <DownOutlined />
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item key="logout" @click="handleLogout">
                  <LogoutOutlined />
                  <span>退出登录</span>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </a-layout-header>

      <!-- 内容区 -->
      <a-layout-content class="content" :class="{ 'content-mobile': isMobile }">
        <router-view />
      </a-layout-content>

      <a-layout-footer class="footer">
        北京牛吃草科技有限公司 © 2026
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { get } from "@/utils/request";
import {
  DashboardOutlined,
  BarChartOutlined,
  SettingOutlined,
  DownOutlined,
  LogoutOutlined,
  CustomerServiceOutlined,
  NotificationOutlined,
} from "@ant-design/icons-vue";
import LottieIcon from "@/components/LottieIcon.vue";
import runOxAnimation from "@/assets/RunOx.json";
import avatarImg from "@/assets/icon/avatar.png";
import { message, Modal } from "ant-design-vue";
import { hasMenu } from "@/utils/permission";
import { authStore } from "@/store/auth";

const router = useRouter();
const route = useRoute();

/** 侧边栏折叠状态 */
const collapsed = ref(false);
/** 是否为移动端（由 Sider breakpoint 回调驱动） */
const isMobile = ref(false);

/**
 * 响应式断点回调
 * 当视口宽度小于 lg (992px) 时自动折叠侧边栏
 */
const onBreakpoint = (broken) => {
  isMobile.value = broken;
  collapsed.value = broken;
};

/** 菜单选中项，与当前路由 path 同步 */
const selectedKeys = ref([route.path]);
/** 展开的子菜单 key */
const openKeys = ref([]);

/** 从 localStorage 读取当前登录用户名 */
const username = computed(
  () =>
    authStore.state.user?.nickname || authStore.state.user?.username || "admin"
);
/** 当前页面标题（取自路由 meta.title） */
const currentTitle = computed(() => route.meta.title || "");

/** 子菜单可见性：只要有一个子菜单项有权限就显示父菜单 */
const hasOrderMenu = computed(() =>
  [
    "/order/daily",
    "/order/app-daily",
    "/order/hourly-payment",
    "/order/link-stats",
    "/order/customer-service-stats",
    "/order/hlb-service-transfer-stats",
    "/order/app-monthly",
    "/order/ltv",
    "/order/ltv-v2",
    "/order/pay-refund-daily",
    "/order/daily-stat",
    "/order/deduction-tag-daily",
    "/order/deduction-forecast-v2",
  ].some(hasMenu)
);
const hasSystemMenu = computed(() =>
  ["/system/user", "/system/role"].some(hasMenu)
);
const hasOperateMenu = computed(() =>
  [
    "/operate/user-query",
    "/operate/external-agreement-conf",
    "/operate/ocean-engine-conversion",
    "/operate/fusion-payment-config",
    "/operate/ad-platform-app",
  ].some(hasMenu)
);
const hasAdMenu = computed(() => ["/ad/rules"].some(hasMenu));

/** 点击菜单项时跳转对应路由 */
const handleMenuClick = ({ key }) => {
  router.push(key);
};

/** 退出登录：弹出确认框 → 清除 token → 跳转登录页 */
const handleLogout = () => {
  Modal.confirm({
    title: "确认退出",
    content: "确定要退出登录吗？",
    okText: "确认",
    cancelText: "取消",
    onOk() {
      authStore.clearAuth();
      message.success("已退出登录");
      router.push("/login");
    },
  });
};

/* ---------- 心跳：定时验证 token 是否仍有效 ---------- */
// 每 5 分钟调用一次 /auth/me；若后端已因密码被修改而使 token 失效，
// 接口会返回 401，request.js 全局拦截器将自动清除认证并跳转登录页。
const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 分钟
let heartbeatTimer = null;

onMounted(() => {
  heartbeatTimer = setInterval(async () => {
    if (!authStore.state.token) return;
    try {
      await get("/v1/analytics/auth/me");
    } catch {
      // 401 已由 request.js 处理（clearAuth + router.push('/login')）
    }
  }, HEARTBEAT_INTERVAL);
});

onUnmounted(() => {
  clearInterval(heartbeatTimer);
});
</script>

<style scoped>
/* ===== 侧边栏（浅灰背景 chanjing 风格） ===== */
.app-sider {
  overflow-y: auto;
  height: 100vh;
  position: sticky;
  top: 0;
  left: 0;
  background: #f8f9fb !important;
  border-right: 1px solid #eceef2;
}

.app-sider :deep(.ant-layout-sider-children) {
  background: #f8f9fb;
}

/* 折叠触发器 */
.app-sider :deep(.ant-layout-sider-trigger) {
  background: #f0f1f3;
  color: #666;
  border-top: 1px solid #eceef2;
}

.sider-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 16px;
  overflow: hidden;
  border-bottom: 1px solid #eceef2;
}

.logo-img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.logo-text {
  color: #333333;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
}

/* ===== 菜单样式覆盖 ===== */
.app-menu {
  background: transparent !important;
  border-inline-end: none !important;
  padding: 8px;
}

/* 菜单项基础样式 */
.app-menu :deep(.ant-menu-item),
.app-menu :deep(.ant-menu-submenu-title) {
  color: #333333 !important;
  border-radius: 8px !important;
  margin: 2px 0 !important;
  transition: all 0.25s ease;
}

/* 菜单项悬停 */
.app-menu :deep(.ant-menu-item:hover),
.app-menu :deep(.ant-menu-submenu-title:hover) {
  background-color: #ffffff !important;
  color: #ff6a39 !important;
}

/* 菜单项选中态：白色背景 + 淡阴影 + 橙色文字 */
.app-menu :deep(.ant-menu-item-selected) {
  background-color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  color: #ff6a39 !important;
  font-weight: 500;
}

.app-menu :deep(.ant-menu-item-selected .anticon) {
  color: #ff6a39 !important;
}

/* 子菜单展开时标题样式 */
.app-menu :deep(.ant-menu-submenu-selected > .ant-menu-submenu-title) {
  color: #ff6a39 !important;
}

.app-menu :deep(.ant-menu-submenu-selected > .ant-menu-submenu-title .anticon) {
  color: #ff6a39 !important;
}

/* 子菜单内容区域 */
.app-menu :deep(.ant-menu-sub.ant-menu-inline) {
  background: transparent !important;
}

/* 移除选中态左侧蓝色竖条 */
.app-menu :deep(.ant-menu-item-selected::after) {
  display: none !important;
}

/* ===== 顶部导航 ===== */
.header {
  background: #ffffff;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid #eceef2;
}

.breadcrumb {
  flex: 1;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
  cursor: pointer;
}

.username {
  font-size: 14px;
}

@media (max-width: 576px) {
  .username {
    display: none;
  }

  .header {
    padding: 0 12px;
  }
}

/* ===== 内容区域 ===== */
.content {
  margin: 24px;
  min-height: 280px;
  background: transparent;
}

.content-mobile {
  margin: 12px;
}

.footer {
  text-align: center;
  color: #999;
}
</style>
